import { Controller } from 'react-hook-form';
import { Checkbox, ButtonSecondary, ButtonType } from '@ui/src';
import { RiskScoreCalculationType } from '../../hoc/types';
import { SettingsCalculatedFormTypes } from './types';

import cn from './form.module.css';

const SettingsCalculatedForm = ({
  control,
  onSubmit,
  requestInProgress,
  updateAllowed,
}: SettingsCalculatedFormTypes) => (
  <form className={cn.settingsCalculatedForm} onSubmit={onSubmit}>
    <div className={cn.settingsCalculateFormContent}>
      <Controller
        control={control}
        name="calculationType"
        render={({ field: { onChange, value, name } }) => (
          <div className={cn.settingsCalculatedFormLeft}>
            <div className={cn.settingsCalculatedFormLeftTitle}>
              Risk score calculation rule
            </div>
            <div className={cn.settingsCalculatedFormGroup}>
              <Checkbox
                type="radio"
                name={`${name}-weight`}
                checked={value === RiskScoreCalculationType.WEIGHT}
                onChange={() => onChange(RiskScoreCalculationType.WEIGHT)}
                title="Calculate by weight"
                disabled={!updateAllowed}
              />
            </div>
            <div className={cn.settingsCalculatedFormGroup}>
              <Checkbox
                type="radio"
                name={`${name}-max-value`}
                checked={value === RiskScoreCalculationType.MAX}
                onChange={() => onChange(RiskScoreCalculationType.MAX)}
                title="Calculate by Max. Value"
                disabled={!updateAllowed}
              />
            </div>
          </div>
        )}
      />
    </div>

    {updateAllowed && (
      <ButtonSecondary
        className={`button-white ${cn.settingsCalculatedFormSubmit}`}
        type={ButtonType.SUBMIT}
        text={requestInProgress ? 'Loading...' : 'Apply'}
        bold
      />
    )}
  </form>
);

export default SettingsCalculatedForm;
